<!-- TEMPLATE -->
<template>
  <div class="row">
    <div class="col-lg-12">
      <v-card color="#272a3d" dark width="100%">
        <v-card-title>
          Submitted Phishing Emails
          <v-spacer></v-spacer>
          <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details>
          </v-text-field>
        </v-card-title>

        <v-card-title v-if="selectedRows.length > 0">
          <v-row>
            <v-col lg="6">
              <v-row>
                <v-col sm="1" lg="1">
                  <v-btn rounded icon @click="deleteRows()" class="btn btn-icon" dark>
                    <v-icon color="red"> mdi-delete </v-icon>
                  </v-btn>
                </v-col>
                <v-col sm="3" lg="3">
                  <v-select style="margin-top: 3px; margin-left: -12p" align="center" label="status" outlined dense
                    v-model="selectedStatus" :items="this.status">
                  </v-select>
                </v-col>
                <v-col>
                  <v-btn rounded icon style="margin-left: -12px" @click="updateStatusRows()" class="btn btn-icon" dark>
                    <v-icon color="white">mdi-content-save</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-title>

        <v-data-table :headers="columns" :items="emails" item-key="id" :search="search" :sort-by="['createdAt']"
          :sort-desc="[true]" show-select v-model="selectedRows" class="mytable">
          <template v-slot:item.createdAt="{ item }">
            <v-chip small> {{ item.createdAt | toReadableDate }}</v-chip>
          </template>

          <template v-slot:item.analysisResult.score="{ item }">
            <v-chip :color="getColorScore(item.analysisResult.score)" dark small>
              {{ item.analysisResult.score }}
            </v-chip>
          </template>

          <template v-slot:item.analysisResult.rules="{ item }">
            <span v-for="i in item.analysisResult.rules" :key="i">{{ i.name }}
            </span>
          </template>

          <template v-slot:item.status="{ item }">
            <v-chip v-if="getTicketStatus(item) == 'open'" :color="'orange'" small>{{ getTicketStatus(item) }}</v-chip>
            <v-chip v-if="getTicketStatus(item) == 'verified'" :color="'red'" small>{{ getTicketStatus(item) }}</v-chip>
            <v-chip small v-if="getTicketStatus(item) == 'reported'" :color="'primary'">{{ getTicketStatus(item) }}
            </v-chip>
            <v-chip small v-if="getTicketStatus(item) == 'resolved'" :color="'green'">
              {{ getTicketStatus(item) }}</v-chip>
            <v-chip small v-if="getTicketStatus(item) == null" :color="'grey'">created</v-chip>
          </template>




          <template v-slot:item.actions="{ item }">
            <v-btn v-on:click="seeDetails(item.id)" :value="item.id" class="btn btn-icon">
              <v-icon>mdi-information-outline</v-icon>
            </v-btn>
          </template>




        </v-data-table>
      </v-card>
    </div>
  </div>
</template>

<!-- SCRIPT -->
<script>
//import UserInfoStore from '../app/user-info-store';
import PhishingApi from "../app/phishing-api";

export default {
  name: "Home",
  data: function () {
    return {
      search: "",
      selectedRows: [],
      selectedStatus: "",
      status: ["open", "verified", "reported", "resolved"],
      columns: [
        // { text: 'Email ID', value: 'email_id', sortable: true, align: 'start' },
        {
          text: "Reported by",
          value: "sender_email",
          sortable: true,
          align: "start",
        },
        {
          text: "Sender",
          value: "sender.email",
          sortable: true,
          align: "start",
        },
        {
          text: "Subject",
          value: "subject",
          sortable: true,
          align: "start",
        },
        {
          text: "Timestamp",
          value: "createdAt",
          sortable: true,
          align: "start",
        },
        {
          text: "Score",
          value: "analysisResult.score",
          sortable: true,
          align: "start",
        },
        {
          text: "Rules",
          value: "analysisResult.rules",
          sortable: true,
          align: "start",
        },
        { text: "Status", value: "status", sortable: true, align: "start" },
      ],
      status: ["open", "verified", "reported", "resolved"],
      emails: [],
    };
  },
  mounted() {
    this.noDataLoading = 1;
    this.fetchData();
  },
  computed: {},
  methods: {
    fetchData() {
      //this.$store.dispatch('refreshEmailStatiEmailstics')
      PhishingApi.getPhishingEmails()
        .then((response) => {
          this.emails = response;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getColorScore: function (number) {
      if (number > 50) return "red";
      else if (number > 20) return "orange";
      else return "green";
    },
    getTicketStatus(item) {
      try {
        return item.status[item.status.length - 1].ticket;
      } catch (e) {
        return null;
      }
    },
    deleteRows() {
      return;
    },
    updateStatusRows() {
      return;
    },
  },
  filters: {
    toReadableDate(value) {
      return new Date(value * 1000).toLocaleString();
    },
    boolToUpDown(value) {
      return value ? "up" : "down";
    },
  },
  components: {},
};
</script>

<!-- Style -->
<style>
</style>